import * as React from 'react';
import { Menu, Row, Col, Layout } from 'antd';
import { withRouter, RouteComponentProps } from "react-router-dom";
import { WithTranslation, withTranslation } from 'react-i18next';
import HttpService from '../services/http.service';
import i18next from 'i18next';
const { Content, Footer } = Layout



interface FooterProps extends WithTranslation, RouteComponentProps {
    footerLogo?: any
}

class FooterView extends React.Component<FooterProps> {
    public render() {
        const { t } = this.props       

        return <Footer>
            <div className={"fi-footer-logo"}><img src={this.props.footerLogo} height={50} /></div>
            <div className={"footer-text"}>
              {t("Copyright")} {new Date().getFullYear()} {t("F.initiatives all rights reserved")} - <a href={this.getTermAndConditionLink()} target="_blanck">{t("Terms of Use")}</a> -<a href={this.getDataLink()} target="_blanck">{t("Data Subject Right")}</a>  - <a href={this.getCookiePolicyLink()} target="_blank">{t("Cookies Policy")}</a>
            </div>
        </Footer>
    }
    
  getDataLink(): string | undefined {
    return "https://www.f-initiatives.com/demarche-donnees-personnelles/"
  }
  getCookiePolicyLink(): string | undefined {
    return "https://www.f-initiatives.com/politique-de-confidentialite-relative-au-site-fi-initiatives/"
  }
  getTermAndConditionLink(): string | undefined {
    return "https://www.f-initiatives.com/mentions-legales/"
  }
}
export default withRouter(withTranslation()(FooterView))